import React, { useEffect, useState } from "react";
import BSNavbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputGroup from "react-bootstrap/InputGroup";
import { Link } from "react-router-dom";
import Mana from "./Mana";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { OutboundLink } from "react-ga";
import Settings from "./Settings";
import Typeahead from "./Typeahead";
import classNames from "classnames";
import logo from "../assets/logo.png";
import { push } from "connected-react-router";
import styles from "../styles/Navbar.module.scss";
import useDarkMode from "use-dark-mode";
import { useDispatch } from "react-redux";

const Navbar = () => {
  const darkMode = useDarkMode(false);
  const dispatch = useDispatch();
  const [navbar, setNavbar] = useState();
  const [showSettings, setShowSettings] = useState(false);

  useEffect(async () => {
    const res = await fetch("/api/navbar/");
    const json = await res.json();
    setNavbar(json);
  }, []);

  const navbarConfig = [
    {
      id: "navbar-cards",
      submenu: [
        { href: "/top", value: "Top Cards" },
        { href: "/top/salt", value: "Saltiest Cards" },
        {
          id: "navbar-cards-by-color",
          submenu: [
            { color: "w", href: "/top/w", value: "White" },
            { color: "u", href: "/top/u", value: "Blue" },
            { color: "b", href: "/top/b", value: "Black" },
            { color: "r", href: "/top/r", value: "Red" },
            { color: "g", href: "/top/g", value: "Green" },
            { color: "c", href: "/top/colorless", value: "Colorless" },
            { color: "multi", href: "/top/multi", value: "Multicolor" },
          ],
          title: "By Color",
        },
        {
          id: "navbar-cards-by-type",
          submenu: [
            { href: "/top/creatures", value: "Creatures" },
            { href: "/top/instants", value: "Instants" },
            { href: "/top/sorceries", value: "Sorceries" },
            { href: "/top/artifacts", value: "Artifacts" },
            { className: styles.indent, href: "/top/equipment", value: "Equipment" },
            {
              className: styles.indent,
              href: "/top/utility-artifacts",
              value: "Utility Artifacts",
            },
            {
              className: styles.indent,
              href: "/top/mana-artifacts",
              value: "Mana Artifacts",
            },
            { href: "/top/enchantments", value: "Enchantments" },
            { className: styles.indent, href: "/top/auras", value: "Auras" },
            { href: "/top/planeswalkers", value: "Planeswalkers" },
            { href: "/top/lands", value: "Lands" },
            {
              className: styles.indent,
              href: "/top/utility-lands",
              value: "Utility Lands",
            },
            {
              className: styles.indent,
              href: "/top/color-fixing-lands",
              value: "Color-Fixing Lands",
            },
          ],
          title: "By Type",
        },
        { href: "/combos", value: "Combos" },
      ],
      title: "Cards",
    },
    {
      id: "navbar-commanders",
      submenu: [
        { href: "/commanders", value: "Top Commanders" },
        { href: "/partners", value: "Partners" },
        {
          id: "navbar-commanders-mono",
          submenu: [
            { color: "w", href: "/commanders/w", value: "White" },
            { color: "u", href: "/commanders/u", value: "Blue" },
            { color: "b", href: "/commanders/b", value: "Black" },
            { color: "r", href: "/commanders/r", value: "Red" },
            { color: "g", href: "/commanders/g", value: "Green" },
            { color: "c", href: "/commanders/colorless", value: "Colorless" },
          ],
          title: "Mono",
        },
        {
          id: "navbar-commanders-2-color",
          submenu: [
            { colors: "wu", href: "/commanders/wu", value: "Azorius" },
            { colors: "ub", href: "/commanders/ub", value: "Dimir" },
            { colors: "br", href: "/commanders/br", value: "Rakdos" },
            { colors: "rg", href: "/commanders/rg", value: "Gruul" },
            { colors: "gw", href: "/commanders/gw", value: "Selesnya" },
            { colors: "wb", href: "/commanders/wb", value: "Orzhov" },
            { colors: "ur", href: "/commanders/ur", value: "Izzet" },
            { colors: "bg", href: "/commanders/bg", value: "Golgari" },
            { colors: "rw", href: "/commanders/rw", value: "Boros" },
            { colors: "gu", href: "/commanders/gu", value: "Simic" },
          ],
          title: "2 Color",
        },
        {
          id: "navbar-commanders-3-color",
          submenu: [
            { colors: "wub", href: "/commanders/wub", value: "Esper" },
            { colors: "ubr", href: "/commanders/ubr", value: "Grixis" },
            { colors: "brg", href: "/commanders/brg", value: "Jund" },
            { colors: "rgw", href: "/commanders/rgw", value: "Naya" },
            { colors: "gwu", href: "/commanders/gwu", value: "Bant" },
            { colors: "wbg", href: "/commanders/wbg", value: "Abzan" },
            { colors: "urw", href: "/commanders/urw", value: "Jeskai" },
            { colors: "bgu", href: "/commanders/bgu", value: "Sultai" },
            { colors: "rwb", href: "/commanders/rwb", value: "Mardu" },
            { colors: "gur", href: "/commanders/gur", value: "Temur" },
          ],
          title: "3 Color",
        },
        {
          id: "navbar-commanders-4-5-color",
          submenu: [
            { colors: "wubr", href: "/commanders/wubr", value: "Yore-Tiller" },
            { colors: "ubrg", href: "/commanders/ubrg", value: "Glint-Eye" },
            { colors: "brgw", href: "/commanders/brgw", value: "Dune-Brood" },
            { colors: "rgwu", href: "/commanders/rgwu", value: "Ink-Treader" },
            { colors: "gwub", href: "/commanders/gwub", value: "Witch-Maw" },
            { colors: "wubrg", href: "/commanders/wubrg", value: "5 Color" },
          ],
          title: "4+ Color",
        },
      ],
      title: "Commanders",
    },
    {
      id: "navbar-sets",
      submenu: [
        { href: "/sets", value: "All Sets" },
        ...(navbar?.sets || []).map(({ code, icon_svg_uri, name }) => ({
          className: styles.indent,
          code,
          href: `/sets/${code}`,
          icon_svg_uri,
          value: name,
        })),
        { href: "/precon", value: "Precon Upgrades" },
      ],
      title: "Sets",
    },
    {
      id: "navbar-themes",
      submenu: [
        { href: "/companions", value: "Companions" },
        { href: "/themes", value: "Themes" },
        ...(navbar?.themes || []).map(({ key, name }) => ({
          className: styles.indent,
          href: `/themes/${key}`,
          value: name,
        })),
        { href: "/tribes", value: "Tribes" },
        ...(navbar?.tribes || []).map((tribe) => ({
          className: styles.indent,
          href: `/tribes/${tribe.toLowerCase()}`,
          value: tribe,
        })),
      ],
      title: "Themes",
    },
  ];

  const handleRandom = async () => {
    const res = await fetch(`/api/random/`);
    const json = await res.json();
    dispatch(push(json));
  };

  const handleSearch = async (value) => {
    if (value.length > 0 && value[0].length > 0) {
      const res = await fetch(`/api/route/?cc=${value[0]}`);
      const json = await res.json();
      dispatch(push(json));
    }
  };

  return (
    <>
      <Settings handleClose={() => setShowSettings(false)} show={showSettings} />
      <BSNavbar
        className={classNames(styles.navbar, { [styles.dark]: darkMode.value }, "shadow")}
        collapseOnSelect
        expand="lg"
        bg="dark"
        variant="dark"
      >
        <BSNavbar.Brand>
          <Link to="/">
            <img alt="EDHREC" className={styles.logo} src={logo} />
          </Link>
        </BSNavbar.Brand>
        <BSNavbar.Toggle />
        <BSNavbar.Collapse id="navbar">
          <Nav className="mr-auto">
            <NavDropdown title="Community">
              <NavDropdown.Item
                as={OutboundLink}
                rel="noopener noreferrer"
                target="_blank"
                to="https://articles.edhrec.com"
              >
                <span>
                  <FontAwesomeIcon className={styles.communityIcon} fixedWidth icon="rss-square" />
                  {" EDHREC Articles "}
                </span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={OutboundLink}
                rel="noopener noreferrer"
                target="_blank"
                to="https://www.youtube.com/channel/UCApiDwDpn_JpzRGLZKrdr1g"
              >
                <span>
                  <FontAwesomeIcon className={styles.communityIcon} fixedWidth icon="podcast" />
                  {" EDHRECast "}
                </span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={OutboundLink}
                rel="noopener noreferrer"
                target="_blank"
                to="https://edhwiki.com"
              >
                <FontAwesomeIcon className={styles.communityIcon} fixedWidth icon="user-edit" />
                <span>{" EDHWiki "}</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={OutboundLink}
                rel="noopener noreferrer"
                target="_blank"
                to="https://commandersherald.com"
              >
                <FontAwesomeIcon className={styles.communityIcon} fixedWidth icon="newspaper" />
                <span>{" Commander's Herald "}</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={OutboundLink}
                rel="noopener noreferrer"
                target="_blank"
                to="https://commanderspellbook.com"
              >
                <svg
                  className={classNames(styles.commanderSpellbook, styles.communityIcon)}
                  width="20"
                  height="16"
                  version="1.1"
                  viewBox="0 0 5.2917 4.2333"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g transform="translate(-71.058 -99.961)">
                    <path
                      d="m76.13 101.81a1.3519 1.3519 0 0 0-0.1412-0.39206l0.0014 8.3e-4 0.08389-0.22521-0.12555-0.12531-0.12543-0.12543-0.18979 0.0706a1.1217 1.1217 0 0 0-0.42182-0.18979l-0.08778-0.19188h-0.35464l-0.0966 0.21177a1.321 1.321 0 0 0-0.39076 0.19473l-0.22356-0.0834-0.12555 0.12519-0.12531 0.12531 0.07295 0.19627c-0.02647 0.0309-0.05224 0.063-0.07754 0.0953v1e-3l0.27133 0.437a2.3167 2.3167 0 0 1 0.23191-0.27933l0.0055-6e-3c0.0099-0.01 0.01989-0.0196 0.03-0.0294l0.01965-0.0186a1.6958 1.6958 0 0 1 0.13378-0.11331c0.11449-0.0871 0.23297-0.14343 0.34993-0.16944l0.01306-3e-3c0.0081-2e-3 0.01624-3e-3 0.02436-4e-3a0.66315 0.66315 0 0 1 0.48795 0.11637c0.0091 7e-3 0.01812 0.0129 0.02706 0.0201 4e-3 3e-3 0.0079 6e-3 0.01177 0.01 0.28957 0.2418 0.36911 0.66432 0.18826 1.0087a0.78234 0.78234 0 0 1-0.17202 0.22215l-0.0025 2e-3c-0.0031 3e-3 -0.0064 5e-3 -0.0095 8e-3a0.6688 0.6688 0 0 1-0.10866 0.0739 0.68245 0.68245 0 0 1-0.25486 0.0824 0.67268 0.67268 0 0 1-0.37452-0.0754c-0.12308-0.0635-0.23027-0.16542-0.34122-0.25425-0.01718-0.0136-0.03377-0.0282-0.05036-0.0432-0.11472-0.1212-0.2132-0.25804-0.30592-0.40124h-0.0014l-0.27603-0.44559v7.4e-4a2.7544 2.7544 0 0 0-0.1752-0.22897l0.07589-0.20332-0.12543-0.12496-0.12484-0.12543-0.22521 0.084 0.0049 8e-3a1.3474 1.3474 0 0 0-0.37982-0.19649l-0.09978-0.21848h-0.35464l-0.08577 0.18824a1.1178 1.1178 0 0 0-0.43453 0.1872l-0.20262-0.0755-0.12543 0.12484-0.12531 0.12531 0.08401 0.22521 0.016-0.01a1.3463 1.3463 0 0 0-0.15296 0.41088l-0.2118 0.0966v0.35464l0.2118 0.0967a1.3378 1.3378 0 0 0 0.15296 0.41121l-0.01683-0.0102-0.08401 0.2252 0.12531 0.12531 0.12543 0.12543 0.20473-0.0764a1.1277 1.1277 0 0 0 0.10448 0.0646l0.02353 0.013 0.01177 6e-3a1.105 1.105 0 0 0 0.29239 0.10095l0.08742 0.19144h0.35464l0.09919-0.21803-0.0029-7.4e-4a1.3134 1.3134 0 0 0 0.3824-0.19602l-0.0052 8e-3 0.2258 0.0834 0.12543-0.12542 0.12543-0.12532-0.07683-0.2059c0.02412-0.0279 0.04707-0.0566 0.0706-0.0858l-0.2731-0.43866a2.3289 2.3289 0 0 1-0.20685 0.25486c-0.01659 0.0149-0.03318 0.0295-0.05036 0.0432-0.11143 0.0888-0.21862 0.19073-0.34122 0.25426a0.67244 0.67244 0 0 1-0.37452 0.0754 0.68245 0.68245 0 0 1-0.25486-0.0824 0.6688 0.6688 0 0 1-0.1086-0.0739c-0.0032-3e-3 -0.0064-5e-3 -0.0095-8e-3l-0.0026-2e-3a0.78199 0.78199 0 0 1-0.17214-0.22238c-0.18061-0.3444-0.10095-0.76693 0.18826-1.0087 0.0038-3e-3 0.0075-6e-3 0.01177-9e-3 0.0089-7e-3 0.01812-0.0136 0.0273-0.0202a0.66327 0.66327 0 0 1 0.48795-0.11637c0.0081 1e-3 0.01624 3e-3 0.02436 4e-3l0.01306 3e-3c0.11696 0.026 0.23533 0.0824 0.34993 0.16943a1.6958 1.6958 0 0 1 0.13378 0.11331c0.0065 6e-3 0.01306 0.0118 0.01965 0.0186 0.01012 0.01 0.02012 0.0195 0.03001 0.0294l0.0055 6e-3c0.1246 0.12672 0.23156 0.27063 0.32946 0.42359l0.2771 0.44688a2.7551 2.7551 0 0 0 0.18979 0.24333l-0.0706 0.1892 0.12543 0.12531 0.12543 0.12543 0.21615-0.0806a1.2848 1.2848 0 0 0 0.3857 0.19003l0.09742 0.21356h0.35464l0.08954-0.19603a1.1105 1.1105 0 0 0 0.26815-0.0964l0.01177-6e-3 0.02353-0.0129a1.1426 1.1426 0 0 0 0.11437-0.0715l0.19179 0.0715 0.25074-0.25074-0.08389-0.22521-0.0021 1e-3a1.3414 1.3414 0 0 0 0.14201-0.39276l0.0013 6e-3 0.21862-0.0999v-0.35452l-0.2184-0.0999z"
                      strokeWidth=".011766"
                    />
                  </g>
                </svg>
                <span>{" Commander Spellbook "}</span>
              </NavDropdown.Item>
            </NavDropdown>
            {navbarConfig.map(({ id, submenu, title }) => (
              <NavDropdown id={id} key={id} title={title}>
                {submenu.map(({ className, href, icon_svg_uri, id, submenu, title, value }) =>
                  submenu ? (
                    <NavDropdown id={id} key={id} title={title}>
                      {submenu.map(({ className, color, colors, href, value }) => (
                        <NavDropdown.Item as={Link} className={className} key={href} to={href}>
                          <span className={styles.manaRow}>
                            {(colors ? [...colors] : color ? [color] : []).map((color) => (
                              <Mana color={color} key={color} />
                            ))}
                            <span className={styles.text}>{value}</span>
                          </span>
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>
                  ) : (
                    <NavDropdown.Item as={Link} className={className} key={href} to={href}>
                      <span>
                        {icon_svg_uri && (
                          <img alt="value" className={styles.setIcon} src={icon_svg_uri} />
                        )}
                        {value}
                      </span>
                    </NavDropdown.Item>
                  )
                )}
              </NavDropdown>
            ))}
            <Nav.Link as={Link} to="/recs">
              Recs
            </Nav.Link>
          </Nav>
          <InputGroup className={styles.search}>
            <Typeahead
              clearOnChange
              onChange={handleSearch}
              placeholder="Search"
              showLoading
              spinner
            />
          </InputGroup>
          <div className={styles.button}>
            <Button onClick={handleRandom} variant="light">
              <FontAwesomeIcon icon="random" />
            </Button>
          </div>
          <div className={styles.button}>
            <Button onClick={() => setShowSettings(true)} variant="light">
              <FontAwesomeIcon icon="cog" />
            </Button>
          </div>
        </BSNavbar.Collapse>
      </BSNavbar>
    </>
  );
};

export default Navbar;
